"use client";

import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { useEffect, useRef, useState } from "react";

type SpoilerProps = {
  children: React.ReactNode;
  openButtonText?: string;
  closeButtonText?: string;
};

/**
 * ネタバレを含むコンテンツを折りたたむコンポーネント
 */
export default function Spoiler({
  children,
  openButtonText = "内容を見る（ネタバレがあります）",
  closeButtonText = "内容を閉じる",
}: SpoilerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [children]);

  return (
    <div className="my-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center justify-center gap-2 rounded-lg border-2 border-dashed border-purple-300 bg-purple-50 px-4 py-1.5 text-purple-700 transition-all duration-300 hover:border-purple-400 hover:bg-purple-100"
      >
        {isOpen ? <EyeSlashIcon className="size-5" /> : <EyeIcon className="size-5" />}
        <span className="font-medium">{isOpen ? closeButtonText : openButtonText}</span>
      </button>

      <div
        ref={contentRef}
        className="overflow-hidden transition-all duration-500 ease-out"
        style={{
          maxHeight: isOpen ? `${contentHeight}px` : "0px",
          opacity: isOpen ? 1 : 0,
        }}
      >
        {children}
      </div>
    </div>
  );
}
